import { ServerConfig } from "@/config/config";
import { DossierConfigService } from "./dossier-config-service";
import { Axios } from "@/utils/axios";
import { Parcel } from "@/utils/sendcloud/parcel";
import { SaleSendCloudParcel } from "@/utils/sendcloud/sale-send-cloud-parcel";
import { Sale } from "@/models/base";

export interface IShippingMethod {
	id:number;
	name:string;
}

export class SendcloudServiceClass {
	public readonly url:string = `${ServerConfig.host}/sendcloud`;

	public isConfigured():boolean {
		let conf = DossierConfigService.getSendcloudConfig();
		if (!conf.PrivateKey) return false;
		if (!conf.PublicKey) return false;
		return true;
	}

	async getShippingMethods():Promise<IShippingMethod[]> {
		let result = await Axios.get(`${this.url}/get-shiping-methods`);
		return result.data as IShippingMethod[];
	}

	async createShipment(saleId:number, parcel:Parcel):Promise<Parcel>{
		let result = await Axios.post(`${this.url}/create-shipment/${saleId}`, parcel);
		return new Parcel(result.data);
	}

	async downloadLabel(url:string):Promise<Blob>{
		url = encodeURIComponent(url);
		let result = await Axios.get(`${this.url}/download-label?url=${url}`, {responseType: "blob"});
		return new Blob([result.data], {type: "application/pdf"});
	}

	async getSaleSendcloudParcels(sale:Sale):Promise<SaleSendCloudParcel[]>{
		let result = await Axios.get(`${this.url}/sent-parcels/${sale.ID}`);
		return ((result.data || []) as any[]).map(s=>new SaleSendCloudParcel(s));
	}
}


export const SendcloudService = new SendcloudServiceClass();